var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.34339 10.2191L11.1766 2.30555C11.6314 1.89815 12.3686 1.89815 12.8234 2.30555L21.6566 10.2191C22.3902 10.8763 21.8706 12 20.8332 12H19V20C19 21.1046 18.1046 22 17 22H7C5.89543 22 5 21.1046 5 20V12H3.16678C2.12937 12 1.60983 10.8763 2.34339 10.2191ZM8 15.4568C8 16.9071 9.60777 18.4409 10.7847 19.3695C11.3175 19.7898 11.5839 20 12 20C12.4161 20 12.6825 19.7898 13.2153 19.3695C14.3922 18.441 16 16.9071 16 15.4568C16 13.034 13.7999 12.1295 12 14.001C10.2001 12.1295 8 13.034 8 15.4568Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome3);
export default __webpack_public_path__ + "static/media/home-3.f5c262812d83c9ed94f2df97ed7a2283.svg";
export { ForwardRef as ReactComponent };